// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__WKje3","container":"modal_container__jeH5t","modal-body":"modal_modal-body__4kVOh","closeIcon":"modal_closeIcon__dxKt5"};